import React, { useState, useEffect } from 'react';
import styles from './ContactDetailsUpdateConfirmationPageData.module.scss';
import PageLink from 'components/PageLink/PageLink';

interface Props {
  PageData?: any;
  Model?: any;
  onOk: () => void;
}

const ContactDetailsUpdateConfirmationPageData = ({
  PageData,
  Model,
  onOk,
}: Props) => {
  console.log('Model- confimation mocel', Model);
  // useEffect(() => {
  //     setValues();
  //   }, []);

  // function setValues(){
  //     setEditAddressSubmitting(false);
  // }

  return (
    <div className="Modal-content Modal-content Modal-content--grey">
      <div className="Grid Grid--gutterA Grid--gutter-sm-Bz">
        <div className="Grid-cell u-lg-size1of1 u-textCenter">
          <h3 className="Heading Heading-h3--portal--large u-marginBz">
            {PageData.Header}
          </h3>
          <img
            className="u-marginVsm"
            src={`${process.env.PUBLIC_URL}/images/icons/payment-complete-check.svg`}
          />
        </div>
        <div className="Grid-cell u-lg-size1of1 Modal-buttonWrapper">
          <div className="Customerdetails-modalButtons">
            <div className="u-marginTmd u-textCenter">
              <button
                onClick={() => onOk()}
                className="Button Button--gray Button--mobFull js-modalclose"
              >
                {PageData?.CloseButtonLabel}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactDetailsUpdateConfirmationPageData;
